(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/triss-subscription/assets/javascripts/widget.js') >= 0) return;  svs.modules.push('/modules/triss-subscription/assets/javascripts/widget.js');
"use strict";

setGlobal('svs.trissSubscription.Widget', _ref => {
  let name = _ref.name;
  const widget = Handlebars.helpers.widgetArea({
    hash: {
      name
    }
  });
  if (widget) return React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: widget.string
    }
  });
  return null;
});

 })(window);